import { render, staticRenderFns } from "./LahanDetail.old.vue?vue&type=template&id=571cb4ad"
import script from "./LahanDetail.old.vue?vue&type=script&lang=js"
export * from "./LahanDetail.old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports